"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getEventsProperty;

var _react = _interopRequireDefault(require("react"));

var _visualengineUtils = require("@ali/visualengine-utils");

var _visualengine = require("@ali/visualengine");

var _compareVersions = _interopRequireDefault(require("compare-versions"));

var _code = _interopRequireDefault(require("./code"));

var _index = _interopRequireDefault(require("./i18n/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function defaultConfig(name) {
  return {
    code: (0, _code.default)(name),
    name: name,
    title: name,
    mode: 'javascript'
  };
} // RE < 4.0 的事件设置器


function getEventsV3() {
  var eventsMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['onClick'];
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var items = eventsMap.map(function (event) {
    var dfg = defaultConfig(event.name);
    var e = typeof event === 'string' ? defaultConfig(event) : _objectSpread(_objectSpread({}, dfg), event);
    return {
      name: e.alias || e.name,
      title: e.title,
      fieldStyle: 'block',
      initialValue: e.code,
      setter: /*#__PURE__*/_react.default.createElement(_visualengineUtils.CodeSetter, {
        placeholder: _index.default.get({
          id: 'eventsPropertyPleaseEnter',
          dm: '请输入'
        }),
        mode: e.mode
      })
    };
  });
  return _objectSpread(_objectSpread({
    type: 'composite',
    name: 'events',
    title: _index.default.get({
      id: 'eventsPropertyEventSettings',
      dm: '事件设置'
    }),
    display: 'block',
    tip: {
      content: _index.default.get({
        id: 'eventsPropertyHelp',
        dm: '帮助'
      }),
      url: 'https://lark.alipay.com/vision/docs/event'
    }
  }, options), {}, {
    items: items
  });
} // RE >= 4.0 的事件设置器


function getEventsV4(events) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({
    name: 'events',
    title: _index.default.get({
      id: 'eventsPropertyActionSetting',
      dm: '动作设置'
    }),
    tip: {
      url: 'https://lark.alipay.com/legao/legao/events-call',
      content: _index.default.get({
        id: 'eventsPropertyClickToSeeHow',
        dm: '点击 ? 查看如何设置组件的事件响应动作'
      })
    },
    display: 'accordion',
    initialValue: {}
  }, options), {}, {
    setter: /*#__PURE__*/_react.default.createElement(_visualengineUtils.EventSetter, {
      events: events
    })
  });
} // Recore 渲染版本的事件设置器


function getEvents(events) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = [_objectSpread(_objectSpread({
    name: 'events',
    title: _index.default.get({
      id: 'eventsPropertyActionSetting',
      dm: '动作设置'
    }),
    tip: {
      url: 'https://lark.alipay.com/legao/legao/events-call',
      content: _index.default.get({
        id: 'eventsPropertyClickToSeeHow',
        dm: '点击 ? 查看如何设置组件的事件响应动作'
      })
    },
    display: 'accordion',
    initialValue: {
      ignored: true
    }
  }, options), {}, {
    setter: /*#__PURE__*/_react.default.createElement(_visualengineUtils.EventSetter, {
      events: events
    }),
    ignore: function ignore(value) {
      return value && value.ignored;
    }
  })];
  events.forEach(function (item) {
    return result.push({
      name: item.name,
      display: 'none',
      initialValue: {
        ignored: true
      },
      ignore: function ignore(value) {
        return value && value.ignored;
      }
    });
  });
  return result;
}

function getEventsProperty(events, options) {
  var schemaVersion = _visualengine.Env.getAliSchemaVersion && _visualengine.Env.getAliSchemaVersion();

  if (schemaVersion && (0, _compareVersions.default)(schemaVersion, '1.0.0') >= 0) {
    return getEvents(events, options);
  }

  var RE_VERSION = _visualengine.Env && _visualengine.Env.getEnv('RE_VERSION');

  if (RE_VERSION && parseInt(RE_VERSION, 10) < 4) {
    return getEventsV3(events, options);
  }

  return getEventsV4(events, options);
}

module.exports = exports.default;